// Prices for a checkout promotion (e.g. 30% off). Mirrors the API's promotion.calculateDiscount
// so the price shown matches what Stripe charges: works in cents and rounds once. No promotion,
// a 0% promotion or a free plan all come back with a zero discount.

const toCents = (amount) => {
    const value = Number(amount);
    return Number.isFinite(value) && value > 0 ? Math.round(value * 100) : 0;
};

const normalizePercent = (percent) => {
    const value = Number(percent);
    return Number.isFinite(value) && value > 0 ? Math.min(value, 100) : 0;
};

// Amounts are in dollars.
export function calculateDiscount(amount, discountPercent) {
    const originalCents = toCents(amount);
    const percent = normalizePercent(discountPercent);
    const discountCents = Math.round((originalCents * percent) / 100);

    return {
        originalAmount: originalCents / 100,
        discountPercent: discountCents > 0 ? percent : 0,
        discountAmount: discountCents / 100,
        finalAmount: (originalCents - discountCents) / 100,
    };
}

// Per-month figure for an annual plan. Without a discount it is the whole-dollar
// floor(yearly / 12) Pearl has always shown ($99 for $1,199/year). With one, the discount
// comes off the yearly charge itself, so the per-month figure matches what is billed.
export function annualMonthlyPricing(yearlyPrice, discountPercent) {
    const { finalAmount, discountAmount } = calculateDiscount(yearlyPrice, discountPercent);
    const original = Math.floor((Number(yearlyPrice) || 0) / 12);
    const isDiscounted = discountAmount > 0;

    return {
        original,
        final: isDiscounted ? Math.round((finalAmount / 12) * 100) / 100 : original,
        isDiscounted,
    };
}

// Whole dollars without decimals ($41), anything else with cents ($28.70).
export function formatPlanPrice(amount) {
    const value = Number(amount) || 0;
    const isWhole = Math.round(value * 100) % 100 === 0;
    return value.toLocaleString('en-US', {
        minimumFractionDigits: isWhole ? 0 : 2,
        maximumFractionDigits: isWhole ? 0 : 2,
    });
}

// "30" for 30, "12.5" for 12.5.
export function formatPercent(percent) {
    return String(Number(normalizePercent(percent).toFixed(2)));
}
